var CollapsibleListData_InitialExpandedItems = /* @__PURE__ */ ((CollapsibleListData_InitialExpandedItems2) => {
  CollapsibleListData_InitialExpandedItems2["FIRST"] = "FIRST";
  CollapsibleListData_InitialExpandedItems2["ALL"] = "ALL";
  CollapsibleListData_InitialExpandedItems2["NONE"] = "NONE";
  CollapsibleListData_InitialExpandedItems2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return CollapsibleListData_InitialExpandedItems2;
})(CollapsibleListData_InitialExpandedItems || {});
var CollapsibleListData_Direction = /* @__PURE__ */ ((CollapsibleListData_Direction2) => {
  CollapsibleListData_Direction2["LTR"] = "LTR";
  CollapsibleListData_Direction2["RTL"] = "RTL";
  CollapsibleListData_Direction2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return CollapsibleListData_Direction2;
})(CollapsibleListData_Direction || {});
export {
  CollapsibleListData_Direction,
  CollapsibleListData_InitialExpandedItems
};
//# sourceMappingURL=plugin_collapsible_list.enums.js.map
